import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UserService } from 'src/app/services/userService/user.service';
import { SubscriberService } from 'src/app/services/subscriberService/subscriber.service';
import { Settings } from 'src/app/interfaces/settings';
import { DialogService } from 'src/app/services/dialogService/dialog-service';
import { LanguageService } from 'src/app/services/languageService/language.service';
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.less']
})

export class SettingsComponent implements OnInit {
  env = environment;
  deviceInfo;
  accessibility: Settings;
  readonly defaultSettings: Settings = {
    fontColor: "#fff",
    bgColor: "transparent",
    fontSize: "2.2"
  }
  openSettings: boolean = false;
  constructor(private deviceService: DeviceDetectorService, private userService: UserService, private subscriberService: SubscriberService, private dialogService: DialogService, private languageService: LanguageService) { }

  ngOnInit(): void {
    const device = this.deviceService.getDeviceInfo();
    this.deviceInfo = device.browser + " " + device.browser_version + (device.os_version ? " - " + device.os_version : "");
    this.initSettings();
  }

  // Change Language
  changeLanguage() {
    this.dialogService.openOptionsDialog({
      icon: "fas fa-globe",
      title: "gen_language",
      options: this.languageService.getLanguages(),
      selected: this.languageService.getLanguage(),
      confirm: "gen_save",
      cancel: "gen_cancel"
    }).subscribe(resp => {
      if (resp) {
        this.languageService.setLanguage(resp);
        if (this.userService.getUser()) {
          this.subscriberService.changeProfileLanguage({
            language: resp
          }, this.userService).then(resp => { })
        } else {
          this.userService.getToken().then(respToken => { });
        }
      }
    })
  }

  /** Save subtitles settings in local storage key is accessibility */
  saveSubsSettings() {
    let settings: Settings = JSON.parse(JSON.stringify(this.accessibility));
    settings.fontSize = settings.fontSize + "vw";
    localStorage.setItem("accessibility", JSON.stringify(settings));
    this.openSettings = false;
  }

  /** Reset subtitles settings to default */
  resetSettings() {
    localStorage.removeItem("accessibility");
    this.accessibility = JSON.parse(JSON.stringify(this.defaultSettings));
  }

  /** Cancel the settings which user made and reset them to the init values */
  cancelSettings() {
    this.openSettings = false;
    this.initSettings();
  }

  /** Initialaze subtitles settings  */
  initSettings() {
    if (localStorage.getItem("accessibility")) {
      let settings: Settings = JSON.parse(localStorage.getItem("accessibility"));
      settings.fontSize = parseFloat(settings.fontSize).toString();
      this.accessibility = settings;
    } else {
      this.accessibility = JSON.parse(JSON.stringify(this.defaultSettings));
    }
  }
}